/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Resource_Guide_DescriptionInputs */

const en_blog_resource_guide_description = /** @type {(inputs: Blog_Resource_Guide_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how a product moves from submission to a managed listing.`)
};

const zh_blog_resource_guide_description = /** @type {(inputs: Blog_Resource_Guide_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解产品如何从提交进入可管理的目录页面。`)
};

/**
* | output |
* | --- |
* | "See how a product moves from submission to a managed listing." |
*
* @param {Blog_Resource_Guide_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_resource_guide_description = /** @type {((inputs?: Blog_Resource_Guide_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Resource_Guide_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_resource_guide_description(inputs)
	return zh_blog_resource_guide_description(inputs)
});
export { blog_resource_guide_description as "blog.resource_guide_description" }